import React from "react";
import clsx from "clsx";
import { ReactComponent as ChevronDown } from "common-assets/assets/icons/arrowDown.svg";

import useStyles from "../Dropdown.style";

export const DropdownIconIndicator = ({
  anchorEl,
  value,
  className
}: {
  anchorEl: boolean;
  value: string | string[];
  className?: string;
}) => {
  const c = useStyles({ value });
  return (
    <ChevronDown
      className={clsx(c.icon, anchorEl ? "MuiSelect-iconOpen" : "", className)}
    />
  );
};
